module.exports = {"everyyear":["12-28","12-29","12-30","12-31","01-01","01-02","01-03","01-04","01-05"],"irregular":["2024-02-15","2024-12-27","2025-01-06","2025-12-26"]}


//////////////////
// WEBPACK FOOTER
// ./src/components/mock/base/philipsHollday.json
// module id = 4Ib8
// module chunks = 1